<template>
    <div class="modal fade show d-block" tabindex="-1" role="dialog" style="background: rgba(0,0,0,0.5)">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Plata Factura Furnizor</h5>
                    <button type="button" class="btn-close" @click="$emit('close')"></button>
                </div>
                <div class="modal-body">

                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">Data platii:</label>
                        <div class="col-sm-6">
                            <input type="date" class="form-control" v-model="form.data_plata">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">Tip document:</label>
                        <div class="col-sm-6">
                            <select class="form-select" v-model="form.tip_document" @change="updateDocNumber">
                                <option value="Chitanta">Chitanță</option>
                                <option value="Ordin de plata">Ordin de plată</option>
                                <option value="Dispozitie plata">Dispoziție plată</option>
                                <option value="Bon fiscal">Bon fiscal</option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">Nr. document:</label>
                        <div class="col-sm-6 d-flex">
                            <input type="text" class="form-control me-2" v-model="form.numar_document"
                                placeholder="Nr document">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">Total platit:</label>
                        <div class="col-sm-6">
                            <div class="input-group">
                                <input type="number" step="0.01" class="form-control text-end"
                                    v-model.number="form.total_platit" @input="distributeAmount">
                                <span class="input-group-text">RON</span>
                                <button class="btn btn-integral" type="button" @click="setIntegral">Integral</button>
                            </div>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">Reprezentand:</label>
                        <div class="col-sm-9">
                            <textarea class="form-control" rows="2" v-model="form.explicatii"></textarea>

                            <!-- Accounting Edit & Preview (Admin Only) -->
                            <div class="mt-3 border rounded p-3 bg-light">
                                <div class="d-flex justify-content-between align-items-center mb-2"
                                    style="cursor: pointer" @click="toggleAccounting">
                                    <span class="fw-bold text-primary"><i class="fa-solid fa-book me-1"></i> Contare
                                        Manuală & Previzualizare RJ</span>
                                    <i class="fas" :class="showAccounting ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                </div>

                                <div v-if="showAccounting">
                                    <div class="row g-2 mb-2">
                                        <div class="col-6">
                                            <label class="form-label small text-muted">Cont Debit (Furnizor)</label>
                                            <input type="text" class="form-control form-control-sm"
                                                v-model="form.custom_cont_debit" placeholder="ex: 401">
                                            <small class="text-muted" v-if="!form.custom_cont_debit">Default: 401.{{
                                                furnizorId }}</small>
                                        </div>
                                        <div class="col-6">
                                            <label class="form-label small text-muted">Cont Credit (Sursă)</label>
                                            <input type="text" class="form-control form-control-sm"
                                                v-model="form.custom_cont_credit" placeholder="ex: 5311 sau 5121">
                                            <small class="text-muted" v-if="!form.custom_cont_credit">Default: {{
                                                defaultCredit }}</small>
                                        </div>
                                    </div>

                                    <div class="table-responsive bg-white border rounded">
                                        <table class="table table-sm table-xs mb-0">
                                            <thead class="bg-secondary text-white">
                                                <tr>
                                                    <th colspan="4" class="text-center py-1">Previzualizare Note
                                                        Contabile (Click pe cont pt editare)</th>
                                                </tr>
                                                <tr>
                                                    <th style="width: 25%">Debit</th>
                                                    <th style="width: 25%">Credit</th>
                                                    <th class="text-end">Sumă</th>
                                                    <th>Explicație</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(line, idx) in previewLines" :key="idx">
                                                    <!-- DEBIT -->
                                                    <td @click="startEdit(line, 'debit')"
                                                        class="cursor-pointer position-relative">
                                                        <div v-if="line.isEditingDebit"
                                                            class="d-flex align-items-center">
                                                            <input type="text"
                                                                class="form-control form-control-sm flex-grow-1 me-1"
                                                                style="padding: 0.25rem 0.5rem; height: auto;"
                                                                v-model="line.editDebitVal" @click.stop
                                                                @keyup.enter="saveEdit(line, 'debit')"
                                                                @keyup.esc="cancelEdit(line, 'debit')"
                                                                ref="editInputDebit">
                                                            <button
                                                                class="btn btn-sm btn-success p-0 d-flex align-items-center justify-content-center"
                                                                style="width: 24px; height: 24px;"
                                                                @click.stop="saveEdit(line, 'debit')">
                                                                <i class="fa fa-check" style="font-size: 10px;"></i>
                                                            </button>
                                                            <button
                                                                class="btn btn-sm btn-danger p-0 d-flex align-items-center justify-content-center ms-1"
                                                                style="width: 24px; height: 24px;"
                                                                @click.stop="cancelEdit(line, 'debit')">
                                                                <i class="fa fa-times" style="font-size: 10px;"></i>
                                                            </button>
                                                        </div>
                                                        <div v-else
                                                            :class="{ 'text-primary fw-bold': line.hasCustomDebit }">
                                                            {{ line.debit }} <i v-if="line.hasCustomDebit"
                                                                class="fa fa-pen fa-xs ms-1 text-muted"></i>
                                                        </div>
                                                    </td>

                                                    <!-- CREDIT -->
                                                    <td @click="startEdit(line, 'credit')"
                                                        class="cursor-pointer position-relative">
                                                        <div v-if="line.isEditingCredit"
                                                            class="d-flex align-items-center">
                                                            <input type="text"
                                                                class="form-control form-control-sm flex-grow-1 me-1"
                                                                style="padding: 0.25rem 0.5rem; height: auto;"
                                                                v-model="line.editCreditVal" @click.stop
                                                                @keyup.enter="saveEdit(line, 'credit')"
                                                                @keyup.esc="cancelEdit(line, 'credit')"
                                                                ref="editInputCredit">
                                                            <button
                                                                class="btn btn-sm btn-success p-0 d-flex align-items-center justify-content-center"
                                                                style="width: 24px; height: 24px;"
                                                                @click.stop="saveEdit(line, 'credit')">
                                                                <i class="fa fa-check" style="font-size: 10px;"></i>
                                                            </button>
                                                            <button
                                                                class="btn btn-sm btn-danger p-0 d-flex align-items-center justify-content-center ms-1"
                                                                style="width: 24px; height: 24px;"
                                                                @click.stop="cancelEdit(line, 'credit')">
                                                                <i class="fa fa-times" style="font-size: 10px;"></i>
                                                            </button>
                                                        </div>
                                                        <div v-else
                                                            :class="{ 'text-primary fw-bold': line.hasCustomCredit }">
                                                            {{ line.credit }} <i v-if="line.hasCustomCredit"
                                                                class="fa fa-pen fa-xs ms-1 text-muted"></i>
                                                        </div>
                                                    </td>
                                                    <td class="text-end font-monospace">{{ formatCurrency(line.suma) }}
                                                    </td>
                                                    <td class="small">{{ line.explicatie }}</td>
                                                </tr>
                                                <tr v-if="previewLines.length === 0">
                                                    <td colspan="4" class="text-center text-muted">Completează suma
                                                        pentru previzualizare</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-2">
                                <a href="#" @click.prevent="toggleTable" class="text-primary text-decoration-underline">
                                    <i class="fas" :class="showTable ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                    {{ showTable ? 'Ascunde facturi' : 'Plateste mai multe facturi' }}
                                </a>
                            </div>
                        </div>
                    </div>

                    <!-- Table of Outstanding Invoices -->
                    <div v-show="showTable" class="mt-4">
                        <div v-if="loadingRestante" class="text-center my-3">
                            <div class="spinner-border text-primary" role="status"></div>
                        </div>
                        <div v-else>
                            <div class="table-responsive">
                                <table class="table table-bordered table-sm">
                                    <thead class="table-light">
                                        <tr class="text-center align-middle">
                                            <th>Nr Factură</th>
                                            <th>Data</th>
                                            <th>Scadență</th>
                                            <th>Total factură</th>
                                            <th>Rămas de plătit</th>
                                            <th style="width: 150px;">Sumă repartizată</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="inv in facturiRestante" :key="inv.id">
                                            <td>{{ inv.nr_doc }}</td>
                                            <td>{{ inv.data_doc }}</td>
                                            <td>{{ inv.data_scadenta }}</td>
                                            <td class="text-end">{{ formatCurrency(inv.total) }}</td>
                                            <td class="text-end fw-bold text-danger">{{
                                                formatCurrency(inv.suma_restanta) }}</td>
                                            <td>
                                                <input type="number" step="0.01"
                                                    class="form-control form-control-sm text-end"
                                                    v-model.number="inv.suma_repartizata"
                                                    @input="updateTotalRepartizat">
                                            </td>
                                        </tr>
                                        <tr v-if="facturiRestante.length === 0">
                                            <td colspan="6" class="text-center text-muted">Nu exista facturi restante.
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot class="table-light fw-bold">
                                        <tr>
                                            <td colspan="5" class="text-end">Total suma repartizata pe facturi:</td>
                                            <td class="text-end">{{ formatCurrency(totalRepartizat) }}</td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>

                            <div v-if="Math.abs(form.total_platit - totalRepartizat) > 0.01"
                                class="alert alert-danger mt-2 py-2">
                                <i class="fas fa-exclamation-triangle"></i>
                                Suma platita ({{ formatCurrency(form.total_platit) }}) difera de suma repartizata ({{
                                    formatCurrency(totalRepartizat) }}).
                                Diferenta: {{ formatCurrency(form.total_platit - totalRepartizat) }}.
                            </div>
                        </div>
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-light" @click="$emit('close')">Renunta</button>
                    <button type="button" class="btn btn-primary" @click="save" :disabled="isSaving || hasError">
                        <span v-if="isSaving" class="spinner-border spinner-border-sm me-2"></span>
                        Salveaza Plata
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
    props: {
        factura: Object,
        firmaId: [String, Number],
        furnizorId: [String, Number] // Changed from clientId
    },
    data() {
        return {
            form: {
                tip_document: 'Chitanta',
                numar_document: '',
                data_plata: new Date().toISOString().slice(0, 10),
                total_platit: 0,
                explicatii: '',
                custom_cont_debit: '',
                custom_cont_credit: ''
            },
            showTable: false,
            showAccounting: false,
            facturiRestante: [],
            loadingRestante: false,
            isSaving: false,
        }
    },
    computed: {
        totalRepartizat() {
            return this.facturiRestante.reduce((acc, inv) => acc + (parseFloat(inv.suma_repartizata) || 0), 0);
        },
        hasError() {
            if (Math.abs(this.form.total_platit - this.totalRepartizat) > 0.01) return true;
            if (this.form.total_platit <= 0) return true;
            return false;
        },
        defaultCredit() {
            if (['Chitanta', 'Bon fiscal', 'Dispozitie plata'].includes(this.form.tip_document)) {
                return '5311'; // Casa
            }
            return '5121'; // Banca
        },
        previewLines() {
            if (this.form.total_platit <= 0) return [];

            const globalDebit = this.form.custom_cont_debit || '401';
            const globalCredit = this.form.custom_cont_credit || this.defaultCredit;
            const furnizorIdSuffix = this.furnizorId ? `.${this.furnizorId}` : '';
            const fullGlobalDebit = globalDebit === '401' ? `401${furnizorIdSuffix}` : `${globalDebit}${furnizorIdSuffix}`;

            const lines = [];

            // 1. Lines for allocated invoices
            this.facturiRestante.forEach(inv => {
                const allocated = parseFloat(inv.suma_repartizata) || 0;
                if (allocated > 0) {
                    const lineDebitRaw = inv.custom_debit || globalDebit;
                    const lineCredit = inv.custom_credit || globalCredit;

                    const lineDebitDisplay = lineDebitRaw === '401' ? `401${furnizorIdSuffix}` : (inv.custom_debit ? lineDebitRaw : `${lineDebitRaw}${furnizorIdSuffix}`);

                    lines.push({
                        id_factura: inv.id,
                        debit: lineDebitDisplay,
                        credit: lineCredit,
                        suma: allocated,
                        explicatie: `Plata f. ${inv.id} (${inv.nr_doc})`,
                        hasCustomDebit: !!inv.custom_debit,
                        hasCustomCredit: !!inv.custom_credit,
                        invoiceObj: inv,
                        isEditingDebit: !!inv._isEditingDebit,
                        isEditingCredit: !!inv._isEditingCredit,
                        editDebitVal: inv._editDebitVal || (inv.custom_debit || globalDebit),
                        editCreditVal: inv._editCreditVal || lineCredit
                    });
                }
            });

            // 2. Fallback unallocated
            if (lines.length === 0 && this.form.total_platit > 0) {
                lines.push({
                    debit: fullGlobalDebit,
                    credit: globalCredit,
                    suma: this.form.total_platit,
                    explicatie: this.form.explicatii || `Plata ${this.form.tip_document} (Nerepartizat)`,
                    isGeneric: true
                });
            }

            return lines;
        }
    },
    methods: {
        formatCurrency(value) {
            return new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
        },
        toggleAccounting() {
            this.showAccounting = !this.showAccounting;
        },
        startEdit(line, type) {
            if (line.isGeneric) return;
            this.facturiRestante.forEach(f => {
                f._isEditingDebit = false;
                f._isEditingCredit = false;
            });

            if (type === 'debit') {
                line.invoiceObj._isEditingDebit = true;
                line.invoiceObj._editDebitVal = line.debit;
                this.$nextTick(() => {
                    if (this.$refs.editInputDebit && this.$refs.editInputDebit[0]) this.$refs.editInputDebit[0].focus();
                });
            } else {
                line.invoiceObj._isEditingCredit = true;
                line.invoiceObj._editCreditVal = line.credit;
                this.$nextTick(() => {
                    if (this.$refs.editInputCredit && this.$refs.editInputCredit[0]) this.$refs.editInputCredit[0].focus();
                });
            }
        },
        saveEdit(line, type) {
            if (type === 'debit') {
                let val = line.editDebitVal;
                const suffix = this.furnizorId ? `.${this.furnizorId}` : '';
                if (suffix && val.endsWith(suffix) && val.length > suffix.length) {
                    val = val.substring(0, val.length - suffix.length);
                }
                line.invoiceObj.custom_debit = val;
                line.invoiceObj._isEditingDebit = false;
            } else {
                line.invoiceObj.custom_credit = line.editCreditVal;
                line.invoiceObj._isEditingCredit = false;
            }
        },
        cancelEdit(line, type) {
            if (type === 'debit') line.invoiceObj._isEditingDebit = false;
            else line.invoiceObj._isEditingCredit = false;
        },
        updateDocNumber() {
        },
        async loadFacturiRestante() {
            this.loadingRestante = true;
            try {
                // Endpoint Plati (nested under facturare)
                const response = await axios.get(`/api/facturare/plati/facturi-restante/${this.furnizorId}?id_firma=${this.firmaId}`);
                this.facturiRestante = response.data.data.map(f => ({
                    ...f,
                    suma_repartizata: 0,
                    custom_debit: '',
                    custom_credit: '',
                    _isEditingDebit: false,
                    _isEditingCredit: false,
                    _editDebitVal: '',
                    _editCreditVal: ''
                }));

                if (this.factura) {
                    const found = this.facturiRestante.find(f => f.id === this.factura.id);
                    // Pre-fill amount logic handled by distributeAmount later or user

                    this.form.explicatii = `Plata ${this.factura.f_denumire || ''} Fact nr ${this.factura.serie_doc}${this.factura.nr_doc}`;
                }
            } catch (e) {
                console.error("Eroare incarcare restante", e);
                Swal.fire("Eroare", "Nu s-au putut incarca facturile restante.", "error");
            } finally {
                this.loadingRestante = false;
            }
        },
        toggleTable() {
            this.showTable = !this.showTable;
            if (this.showTable && this.facturiRestante.length === 0) {
                this.loadFacturiRestante();
            }
        },
        setIntegral() {
            if (this.factura) {
                // Find current invoice data
                // If facturiRestante is empty, we might need to rely on this.factura props or wait list?
                // Ideally list is loaded. Or if not loaded, use prop data if basic info there (but sold is better from API list)

                const found = this.facturiRestante.find(f => f.id === this.factura.id);
                if (found) {
                    this.form.total_platit = found.suma_restanta;
                    this.distributeAmount();
                } else {
                    // Fallback to prop if not found in list (e.g. huge lists?)
                    // But usually list should contain it.
                    // If table not loaded yet, trrigger load?
                    if (this.facturiRestante.length === 0) {
                        this.loadFacturiRestante().then(() => {
                            const foundAfter = this.facturiRestante.find(f => f.id === this.factura.id);
                            if (foundAfter) {
                                this.form.total_platit = foundAfter.suma_restanta;
                                this.distributeAmount();
                            }
                        });
                    }
                }
            }
        },
        distributeAmount() {
            const amount = this.form.total_platit;
            if (amount <= 0) return;

            if (this.facturiRestante.length === 0) {
                this.loadFacturiRestante().then(() => {
                    this.performDistribution(amount);
                });
                this.showTable = true;
            } else {
                this.performDistribution(amount);
            }
        },
        performDistribution(totalAmount) {
            let remaining = totalAmount;
            this.facturiRestante.forEach(f => f.suma_repartizata = 0);

            if (this.factura) {
                const current = this.facturiRestante.find(f => f.id === this.factura.id);
                if (current) {
                    const toAlloc = Math.min(remaining, current.suma_restanta);
                    current.suma_repartizata = toAlloc;
                    remaining -= toAlloc;
                }
            }
        },
        updateTotalRepartizat() {
        },
        async save() {
            if (this.hasError) return;

            this.isSaving = true;
            try {
                const payload = {
                    id_firma: this.firmaId,
                    id_furnizor: this.furnizorId,
                    ...this.form,
                    repartizari: this.facturiRestante
                        .filter(f => f.suma_repartizata > 0)
                        .map(f => ({
                            id_factura: f.id,
                            suma: f.suma_repartizata,
                            custom_debit: f.custom_debit || null,
                            custom_credit: f.custom_credit || null
                        }))
                };

                await axios.post('/api/facturare/plati/store', payload);

                Swal.fire("Succes", "Plata salvata cu succes!", "success");
                this.$emit('saved');
                this.$emit('close');

            } catch (e) {
                console.error(e);
                const msg = e.response?.data?.message || "Eroare la salvare.";
                Swal.fire("Eroare", msg, "error");
            } finally {
                this.isSaving = false;
            }
        }
    },
    mounted() {
        this.loadFacturiRestante();
    }
}
</script>

<style scoped>
.modal {
    background-color: rgba(0, 0, 0, 0.5);
}

.cursor-pointer {
    cursor: pointer;
}

.cursor-pointer:hover {
    background-color: #f8f9fa;
}

.table-xs th,
.table-xs td {
    font-size: 0.75rem;
    padding: 0.25rem;
}

.btn-integral {
    background-color: #0d6efd;
    color: white;
    border: none;
    transition: background-color 0.2s ease;
}

.btn-integral:hover {
    background-color: #0b5ed7;
    color: white;
}
</style>
